import { User } from "./user.model"

export class Store {
  id: number
  name: string
  searchLabel: string = ''
  storenum: string
  latitude: number
  longitude: number
  address: string
  city: string
  state: string
  zip: string
  phone: string
  distance: number
  is_deleted: boolean
  last_updated: string
  
  constructor() {
  }

  static buildOne(obj: any): Store {
    let target: Store = Object.assign(new Store(), obj)
    return target
  }

  static buildMany(objs: any[]): Store[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Store.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export interface StoresAndUser {
    stores: Store[]
    user: User   
}

